import styled, { css } from 'styled-components';
import { tokens, palette } from '@plataforma/components';

export const UserMenu = styled.div`
  position: absolute;
  right: ${tokens.spacing.l};
  top: 50%;
  z-index: 15;

  // half height of the avatar
  margin-top: -22px;
`;

/**
 * Trigger and dropdown structure
 *
 * The base structure of the menu consists in a trigger, which now is an Avatar,
 * and a dropdown that'll be toggled by this trigger
 */
export const Trigger = styled.button`
  cursor: pointer;
  margin: 0;
  border: 0;
  background: none;

  &:focus {
    outline: none;
  }
`;

/**
 * Nav
 *
 * The inner items is divided in a navigation element for semanthics purposes
 */
export const Nav = styled.nav`
  background-color: ${palette['color-white']};
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 10px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
  width: 295px;
  box-sizing: border-box;
  padding: 0 ${tokens.spacing.l};
  transform: translateY(-20%);
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s cubic-bezier(0.165, 0.84, 0.44, 1);

  ${({ isOpen }) =>
    !!isOpen &&
    css`
      transform: translateY(0);
      opacity: 1;
      pointer-events: all;
    `};

  ${tokens.font.s};
`;

export const NavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const NavListItem = styled.li`
  padding: ${tokens.spacing.l} 0;
  border-bottom: 1px solid ${palette['color-grey-200']};

  :last-child {
    border-bottom: none;
  }

  &:empty {
    display: none;
  }
`;
